import { gql } from "@apollo/client"

export const GET_TAX_JAR_CONFIG = gql`
  query getTaxJarConfig($id: ID!) {
    getTaxJarConfig(id: $id) {
      id
      baseUrl
      created
      updated
    }
  }
`
